import React from "react";
import { TableCell } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  headerCell: {
    fontWeight: theme.typography.fontWeightBold
  }
}));
function HeaderCell({ children }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(TableCell, { className: classes.headerCell }, children);
}
export {
  HeaderCell
};
//# sourceMappingURL=HeaderCell.js.map
